<script setup lang="ts">
  import ModalDialog from '@/VueComponents/Modals/ModalDialog.vue';
  import resourceHelper from '@/Utils/resourceHelper';
  import { UploadOption } from '@/Types/Enums/uploadOption';
  import { ref } from 'vue';

  const props = defineProps<{
    zipFilesCount?: number,
    nonZipFilesCount?: number,
    fileList?: File[],
    uploadOption?: string
  }>();
  const visible = defineModel<boolean>({ default: false });

  const emit = defineEmits<{ 'close', 'continue' }>();

  function closeModal() {
    visible.value = false;
  }

  function onModalOpen() {
    regenerateText();
  }

  function onModalContinue() {
    emit('continue');
  }

  let warningTitle = ref('');
  let warningPara1 = ref('');
  let warningPara2 = ref('');

  function regenerateText() {
    if (props.uploadOption === UploadOption.selectZipFiles && props.nonZipFilesCount && props.nonZipFilesCount > 1) {
      warningTitle.value = resourceHelper.getString('NonZipFilesWarningTitle', { filesCount: props.nonZipFilesCount });
      warningPara1.value = resourceHelper.getString('NonZipFilesWarningPara1', { filesCount: props.nonZipFilesCount });
      warningPara2.value = resourceHelper.getString('NonZipFilesWarningPara2', { filesCount: props.nonZipFilesCount });
    } else if (props.uploadOption === UploadOption.selectZipFiles && props.nonZipFilesCount && props.nonZipFilesCount === 1) {
      warningTitle.value = resourceHelper.getString('NonZipFileWarningTitle');
      warningPara1.value = resourceHelper.getString('NonZipFileWarningPara1');
      warningPara2.value = resourceHelper.getString('NonZipFileWarningPara2');
    } else {
      if (props.zipFilesCount && props.zipFilesCount > 1) {
        warningTitle.value = resourceHelper.getString('ZipFilesWarningTitle', { filesCount: props.zipFilesCount });
        warningPara1.value = resourceHelper.getString('ZipFilesWarningPara1', { filesCount: props.zipFilesCount });
        warningPara2.value = resourceHelper.getString('ZipFilesWarningPara2', { filesCount: props.zipFilesCount });
      } else {
        warningTitle.value = resourceHelper.getString('ZipFileWarningTitle');
        warningPara1.value = resourceHelper.getString('ZipFileWarningPara1');
        warningPara2.value = resourceHelper.getString('ZipFileWarningPara2');
      }
    }
  }


</script>

<template>
  <ModalDialog
    v-model="visible"
    :title="warningTitle"
    @open="onModalOpen"
    @close="emit('close')"
  >
    <template #default>
      <div>
        {{ warningPara1 }}
      </div>
      <br>
      <div>
        {{ warningPara2 }}
      </div>
    </template>
    <template #footer>
      <button
        class="btn btn-outline-secondary"
        @click="closeModal"
      >
        {{ $localize('Cancel') }}
      </button>
      <button
        class="btn btn-primary"
        @click="onModalContinue"
      >
        {{ $localize('Continue') }}
      </button>
    </template>
  </ModalDialog>
</template>
